import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { clearLogs } from "@/lib/api";
import { formatTime } from "@/lib/format";

const LEVEL_STYLES = {
  info: { dot: "#2563EB", label: "INFO" },
  success: { dot: "#10B981", label: "OK" },
  warning: { dot: "#F59E0B", label: "WARN" },
  error: { dot: "#E11D48", label: "ERR" },
};

export default function ActivityLog({ logs, onCleared }) {
  const handleClear = async () => {
    try {
      await clearLogs();
      toast.success("Log cleared");
      onCleared();
    } catch {
      toast.error("Failed to clear");
    }
  };
  return (
    <div className="flex-1 flex flex-col min-h-0" data-testid="activity-log">
      <div className="px-6 py-3 flex items-center justify-between border-b border-[#eaecf0]">
        <div>
          <div className="overline">Feed</div>
          <div className="font-display text-lg font-medium mt-0.5">Activity Log</div>
        </div>
        <button
          onClick={handleClear}
          data-testid="clear-logs-btn"
          className="p-1 text-[#525252] hover:text-[#BE123C] rounded-sm"
        >
          <Trash2 className="w-3.5 h-3.5" strokeWidth={1.5} />
        </button>
      </div>
      <div className="flex-1 overflow-auto">
        {logs.length === 0 && (
          <div className="px-6 py-8 text-xs text-[#A1A1AA] font-mono">
            No events yet.
          </div>
        )}
        <ul>
          {logs.map((l) => {
            const s = LEVEL_STYLES[l.level] || LEVEL_STYLES.info;
            return (
              <li
                key={l.id}
                className="px-6 py-2.5 border-b border-[#F4F4F5] hover:bg-[#FAFAFA]"
                data-testid={`log-${l.id}`}
              >
                <div className="flex items-center gap-2 mb-0.5">
                  <span
                    className="w-1.5 h-1.5 rounded-full"
                    style={{ background: s.dot }}
                  />
                  <span
                    className="text-[10px] font-mono tracking-wider"
                    style={{ color: s.dot }}
                  >
                    {s.label}
                  </span>
                  <span className="text-[10px] font-mono text-[#A1A1AA] ml-auto">
                    {formatTime(l.timestamp)}
                  </span>
                </div>
                <div className="text-xs text-[#101828] leading-snug">
                  {l.message}
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
